let post1Description = 
`   <p>
        Move the pointer and press the mouse button using the keyboard or a numeric keypad. See 
        <a href="https://support.apple.com/en-in/guide/mac-help/control-the-pointer-using-mouse-keys-mh27469/13.0/mac/13.0" 
            className="xRef AppleTopic">
            Control the pointer using Mouse Keys
        </a>.
    </p>
    <div className="Alert">
        <p className="Note">
            <em>Note: </em>
            When Mouse Keys is on, you can't use the keyboard or numeric keypad to enter text.
        </p>
    </div>
    <p>
        To customise, click the Info button 
        <span className="NoBreak">
            <img src="https://help.apple.com/assets/63BCA927AAE78C58DD7FBE35/63BCA92EAAE78C58DD7FBE76/en_GB/974db3c051f6ac0adaddf1e2fec1001e.png" alt="" height="30" width="30" originalimagename="SharedGlobalArt/IL_InfoCircle.png">
        </span>
        :
    </p>
    <ul>
        <li>
            <p>
                <em>Press the Option key five times to toggle Mouse Keys:</em> 
                Use your keyboard to turn Mouse Keys on or off.
            </p>
        </li>
        <li>
            <p>
                <em>Ignore built-in trackpad when Mouse Keys is on:</em> 
                Disable the trackpad on your Mac when you use Mouse Keys.
            </p>
        </li>
        <li>
            <p>
                <em>Initial delay:</em> 
                Set how quickly the pointer starts moving when you press a key.
            </p>
        </li>
        <li>
            <p>
                <em>Maximum speed:</em> 
                Set the maximum speed at which the pointer moves. 
            </p>
        </li>
    </ul>
    <div className="messageTextEndMarker">&nbsp;</div>
`

let postIReplyPosts = [
    {
        id: "2",
        title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
        reference_to_poster: "2",
        user: {
            id: "2",
            avatar: "",
            name: "mharlieedgington22",
            city: "New York",
            state: "New York State",
            badges: [], //future upgrades
            name_initials_bg_color: "#06b6d4",
            name_initials_text_color: "#fff",
            join_date: "2023-05-01",
            count_of_replies: 4566
        },
        description: 
        `
            <article>
                <blockquote className="messageText SelectQuoteContainer ugc baseHtml">
                    I am seeking out a driver condition for a private client of mine.<br>
                    <br>
                    He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
                    <br>
                    Non-red preferred.<br>
                    <br>
                    Scruffier than nicer would best describe the desired overall condition.<br>
                    <br>
                    Good records without blemishes would be preferred.<br>
                    <br>
                    Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
                    <br>
                    NOT looking for a perfect car.<br>
                    <br>
                    Thanks!
                    <div className="messageTextEndMarker">&nbsp;</div>
                </blockquote>
            </article>
        `,
        replies: [],
        likes: [{
            user_refrence: "1",
            user: {
                name: "Edward 96GTS",
            }
        },{
            user_refrence: "2",
            user: {
                name: "slm",
            }
        },{
            user_refrence: "3",
            user: {
                name: "Oengus",
            }
        },{
            user_refrence: "4",
            user: {
                name: "GLENN@TEAM AI",
            }
        },{
            user_refrence: "5",
            user: {
                name: "SCantera",
            }
        },{
            user_refrence: "6",
            user: {
                name: "msdesignltd",
            }
        },{
            user_refrence: "7",
            user: {
                name: "ashwin murali",
            }
        },{
            user_refrence: "8",
            user: {
                name: "Untertaker555 ",
            }
        },{
            user_refrence: "9",
            user: {
                name: "d43qd3dsa",
            }
        }], //( Array of references to people who liked the post )
        date_of_post: "2023-05-01 04:15:03",
        display_order: 23,
        status: "active",
        count_of_replies: 345,
    },
    {
        id: "3",
        title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
        reference_to_poster: "2",
        user: {
            id: "2",
            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
            name: "PortAreaGuy17",
            city: "Phoenix",
            state: "Arizona",
            badges: [], //future upgrades
            name_initials_bg_color: "#06b6d4",
            name_initials_text_color: "#fff",
            join_date: "2021-75-01",
            count_of_replies: 56
        },
        description: 
        `
            Wow.....100k? 
            <br>
            <br>
            I have not had a car painted [76 BB] since the early 80s. Don't plan on doing it anytime soon. 
            I acquire cars that someone else has made or kept in good condition. No restorations planned in my future.
            <div className="messageTextEndMarker">&nbsp;</div>
        `,
        replies: [],
        likes: [{
            user_refrence: "1",
            user: {
                name: "ditiro sekatuba",
            }
        },{
            user_refrence: "2",
            user: {
                name: "spunk funk",
            }
        },{
            user_refrence: "3",
            user: {
                name: "Corday",
            }
        }], //( Array of references to people who liked the post )
        date_of_post: "2023-05-01 04:15:03",
        display_order: 23,
        status: "active",
        count_of_replies: 345,
        references_reply_id: "2",
        referenced_reply: {
            id: "2",
            description: `
                I am seeking out a driver condition for a private client of mine.<br>
                <br>
                He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
                <br>
                Non-red preferred.<br>
                <br>
                Scruffier than nicer would best describe the desired overall condition.<br>
                <br>
                Good records without blemishes would be preferred.<br>
                <br>
                Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
                <br>
                NOT looking for a perfect car.<br>
                <br>
                Thanks!
                <div className="messageTextEndMarker">&nbsp;</div>
            `,
            user: {
                id: "2",
                name: "PortAreaGuy17",
            },
        }
    }
];

let communities = [
    {
        id: "1",
        title:  "Technology Innovations",
        description:  "",
        forums: [{
            id: "1",
            title: "Technology Support",
            icon: "truck",
            description: "Bastian Technology",
            posts: [{
                id: "1",
                title: "Apple released new Accessibility mouse pad ",
                sub_title: "On your Mac, set options that make the mouse and trackpad easier to use and enable other control methods including Mouse Keys and head pointer.",
                reference_to_poster: "1",
                user: {
                    id: "1",
                    avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                    name: "Jay535",
                    city: "Phoenix",
                    state: "Arizona",
                    badges: [], //future upgrades,
                    name_initials_bg_color: "#06b6d4",
                    name_initials_text_color: "#fff",
                    join_date: "2021-75-01",
                    count_of_replies: 56
                },
                description: post1Description,
                replies: postIReplyPosts,
                likes: [{
                    user_refrence: "1",
                    user: {
                        name: "ditiro sekatuba",
                    }
                },{
                    user_refrence: "2",
                    user: {
                        name: "spunk funk",
                    }
                },{
                    user_refrence: "3",
                    user: {
                        name: "Corday",
                    }
                }],
                date_of_post: "2023-05-01 04:15:03",
                display_order: 23,
                status: "active",
                count_of_replies: 345
            }],
            reference_to_latest_post: "",
            display_order: 1,
            status: "active",
            count_of_posts: 3901,
            count_of_replies: 17520,
            latest_post: {
                id: "1",
                title: "Apple released new Accessibility mouse pad ",
                date_of_post: "2023-05-01 04:15:03",
                user: {
                    id: "1",
                    name: "Jay535"
                }
            }
        },
        {
            id: "2",
            title: "QA Tester",
            icon: "truck",
            description: "Lily's Ice cream",
            posts: [],
            reference_to_latest_post: "",
            display_order: 2,
            status: "active",
            count_of_posts: 0,
            count_of_replies: 0,
        },
        {
            id: "3",
            title: "Politics",
            icon: "truck",
            description: "Any new political news and discussions",
            posts: [],
            reference_to_latest_post: "",
            display_order: 3,
            status: "active",
            count_of_posts: 0,
            count_of_replies: 0,
        }],
        display_order: 1,
        status: "active",
    },
    {
        id: "1",
        title:  "Medical Conditions",
        description:  "",
        forums: [
            
            {
                id: "1",
                title: "Accidents",
                icon: "truck",
                description: "Unintended injuriies",
                posts: [
                
                    {
                        id: "1",
                        title: "Apple released new Accessibility mouse pad ",
                        sub_title: "On your Mac, set options that make the mouse and trackpad easier to use and enable other control methods including Mouse Keys and head pointer.",
                        reference_to_poster: "1",
                        user: {
                            id: "1",
                            avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
                            name: "Jay535",
                            city: "Phoenix",
                            state: "Arizona",
                            badges: [], //future upgrades,
                            name_initials_bg_color: "#06b6d4",
                            name_initials_text_color: "#fff",
                            join_date: "2021-75-01",
                            count_of_replies: 56
                        },
                        description: post1Description,
                        replies: postIReplyPosts,
                        likes: [{
                            user_refrence: "1",
                            user: {
                                name: "ditiro sekatuba",
                            }
                        },{
                            user_refrence: "2",
                            user: {
                                name: "spunk funk",
                            }
                        },{
                            user_refrence: "3",
                            user: {
                                name: "Corday",
                            }
                        }
                        ],
                        date_of_post: "2023-05-01 04:15:03",
                        display_order: 23,
                        status: "active",
                        count_of_replies: 345
                    }
                ],
                reference_to_latest_post: "",
                display_order: 1,
                status: "active",
                count_of_posts: 3901,
                count_of_replies: 17520,
                latest_post: {
                    id: "1",
                    title: "Apple released new Accessibility mouse pad ",
                    date_of_post: "2023-05-01 04:15:03",
                    user: {
                        id: "1",
                        name: "Jay535"
                    }
                }
            },
            {
                id: "2",
                title: "Acne",
                icon: "truck",
                description: "Lily's Ice cream",
                posts: [],
                reference_to_latest_post: "",
                display_order: 2,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "3",
                title: "Addison's disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "4",
                title: "Alzheimer's disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "5",
                title: "Anemia",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "6",
                title: "Anxiety disorders",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "7",
                title: "Asthma",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "8",
                title: "Attention deficit hyperactivity disorder (ADHD)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "9",
                title: "Autism spectrum disorder",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "10",
                title: "Bipolar disorder",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "11",
                title: "Cancer",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "12",
                title: "Cataracts",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "13",
                title: "Celiac disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            ,
            {
                id: "14",
                title: "Chronic fatigue syndrome",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "15",
                title: "Chronic liver disease and cirrhosis",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "16",
                title: "Chronic lower respiratory diseases",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "17",
                title: "Chronic obstructive pulmonary disease (COPD)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "18",
                title: "Crohn's disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "19",
                title: "Cushing's syndrome",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "20",
                title: "Depression",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "21",
                title: "Diabetes",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "22",
                title: "Diabetic retinopathy",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "23",
                title: "Eating disorders",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "24",
                title: "Eczema (atopic dermatitis)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "25",
                title: "Endometriosis",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "26",
                title: "Epilepsy",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "27",
                title: "Erectile dysfunction",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "28",
                title: "Fibromyalgia",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "29",
                title: "Gallstones",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "30",
                title: "Gastroesophageal reflux disease (GERD)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "31",
                title: "Glaucoma",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "32",
                title: "Gout",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "33",
                title: "Hearing loss",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "34",
                title: "Heart disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "35",
                title: "Hemophilia",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "36",
                title: "Hepatitis B",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "37",
                title: "Hepatitis C",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "38",
                title: "Human immunodeficiency virus (HIV)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "39",
                title: "Hypertension",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "40",
                title: "Hyperthyroidism",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "41",
                title: "Hypothyroidism",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "42",
                title: "Influenza and pneumonia",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "43",
                title: "Insomnia",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "44",
                title: "Irritable bowel syndrome (IBS)",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "45",
                title: "Kidney disease",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "46",
                title: "Kidney stones",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
            {
                id: "47",
                title: "Kidney Lupus",
                icon: "truck",
                description: "Any new political news and discussions",
                posts: [],
                reference_to_latest_post: "",
                display_order: 3,
                status: "active",
                count_of_posts: 0,
                count_of_replies: 0,
            },
        ],
        display_order: 1,
        status: "active"
    },
    {
        id: "2",
        title:  "Government Programs",
        description:  "",
        forums: [{
            id: "1",
            title: "Extreme focus",
            icon: "truck",
            description: "Lets talk about some this challenge and blessing of hyper focussing",
            posts: [],
            reference_to_latest_post: "",
            display_order: 2,
            status: "active",
            count_of_posts: 3901,
            count_of_replies: 17520,
            latest_post: {
                id: "1",
                title: "This happens to me all the time. I remember when I was in school , it was so hard for me to switch contexts and go to different classes ",
                date_of_post: "2023-05-01 04:15:03",
                user: {
                    id: "1",
                    name: "Jay535"
                }
            }
        },{
            id: "2",
            title: "Encouragement",
            icon: "truck",
            description: "When people encourage me and say I am very good at some things, It helps me work harder.",
            posts: [],
            reference_to_latest_post: "",
            display_order: 1,
            status: "active",
            count_of_posts: 0,
            count_of_replies: 0,
        }],
        display_order: 1,
        status: "active"
    },
    {
        id: "3",
        title:  "NGO Organisations",
        description:  "",
        forums: [],
        display_order: 3,
        status: "active"
    },
    {
        id: "4",
        title:  "Medical Conditions Discussions",
        description:  "",
        forums: [],
        display_order: 4,
        status: "active"
    },
    {
        id: "5",
        title:  "Accessibility support",
        description:  "",
        forums: [],
        display_order: 5,
        status: "active"
    },
    {
        id: "6",
        title:  "Other discussions",
        description:  "",
        forums: [{
            id: "1",
            title: "Mobility support",
            icon: "truck",
            description: "A place for anyone selling any mobility support equipment",
            posts: [],
            reference_to_latest_post: "",
            display_order: 1,
            status: "active",
            count_of_posts: 3901,
            count_of_replies: 17520,
            latest_post: {
                id: "1",
                title: "Used Wheel chair. Just over under 3 months old ",
                date_of_post: "2023-05-01 04:15:03",
                user: {
                    id: "1",
                    name: "Pete536"
                }
            }
        },{
            id: "2",
            title: "Technology Gadgets",
            icon: "truck",
            description: "Accessibility oriented Technology gadgets",
            posts: [],
            reference_to_latest_post: "",
            display_order: 2,
            status: "active",
            count_of_posts: 1,
            count_of_replies: 223,
            latest_post: {
                id: "1",
                title: "Keyboard for sale , almost new .just used for under a month",
                date_of_post: "2023-05-01 04:15:03",
                user: {
                    id: "1",
                    name: "Joe636"
                }
            }
        }],
        display_order: 6,
        status: "active"
    }, 
    {
        id: "7",
        title:  "Events",
        description:  "",
        forums: [],
        display_order: 7,
        status: "active"
    },
];

//https://remotearmy.io/jobs/nL0NK4C7-customer-success-manager-enterprise
let jobDetails = `<p><span>Filevine is building the seamless intersection between legal and business by creating a world- class platform to help professionals scale. You will be joining our fast-growing Customer Success team responsible for delivering value to, and driving adoption across, our customer base.</span></p><p><br></p><p><b>Customer Success Manager (Enterprise)</b></p><p><span>Filevine Customer Success Managers work closely with our customers to learn their business, understand their goals, and help them create a plan to succeed by maximizing the benefits of the Filevine product suite. This role is perfect for the curious person who is always looking to learn something new, as you’ll have your hands in a little bit of everything serving as your customer’s key point of contact within Filevine, and as their internal champion.</span></p><h3>Customer Consultation and  Solutions Engineering:</h3><ul><li>Develop a deep and broad understanding of the Filevine product suite, and it’s application to legal and other industries</li><li>Become an expert in best practices for each of the Filevine products, and understand the different customer use cases that would lead to different recommendations</li><li>Continuously learn about your customers and their industries through ongoing research and creative conversations, in order to understand where Filevine can provide the most impact</li><li>Create joint account plans with customers that can be regularly tracked using measurable objectives</li><li>Build relationships at multiple levels throughout your customer base, working with owners/partners, COOs, IT Directors, and Case and Quality managers in order to get a full picture of how products are being used and viewed throughout the firm.&nbsp;</li><li>Learn how to embed yourself into a firm to get a 360 degree view of how their firm operates, in order to make recommendations on new or additional applications of Filevine products</li><li>Be prepared to provide technical recommendations&nbsp; and help customers find the resources to implement them</li></ul><h3>Training and Enablement:</h3><ul><li>Work with new and existing Filevine Customers to provide additional training, education, and documentation to drive long term Customer success</li><li>Understand and recommend existing training and enablement resources, and coordinate with internal and partner teams to create where necessary</li><li>Recommend best practices for onboarding new hires and launching new features and functionalities in Filevine</li><li>Serve as the main point of reference for any new or upcoming product features, and how to best take advantage of them</li><p><br></p></ul><h3>Escalation Management</h3><ul><li>Understand high priority product issues and help escalate them internally by providing feedback on business impact to support and product teams, and by gathering additional customer information where appropriate</li><li>Accurately gauge customer temperature, and provide internal visibility to Customers For Life leadership&nbsp;</li><li>Identify areas of customer risk, creating a cross functional plan to resolve, and tracking to resolution</li><li>Provide internal visibility through regular updates in Filevine and Salesforce&nbsp;</li><p><br></p></ul><h3>Growth and Expansion</h3><ul><li>Work with Account Management team to help identify areas of upsell for customers, whether new groups within a firm, or where new products could bring value</li><li>Participate in preparation for contract renewals, focusing both on license retention AND new opportunities</li><p><br></p></ul><h3>Collaboration</h3><ul><li>Coordinate with internal teams such as implementation, product, sales and support in order to effectively meet the needs of your customer</li><li>Lead cross functional teams created to resolve customer escalations, creating plans across teams and tracking progress, and escalating any delays or drops to leadership</li><li>Maintain documentation and provide regular updates through internal systems to provide transparency into efforts and results</li></ul><h3>KPI’s</h3><ul><li>Data points used to assess CSMs include but are not limited to the following. Each is considered just one data point, with the understanding that not all outcomes are under the complete control of the CSM.</li><li>		Net Revenue Retention</li><li>		Resolution of client escalations (taking customers from red to yellow to green)</li><li>		Change in Net Promoter Score</li><li>		Customer account plans in place with progress being tracked</li><li>		Frequency/volume of meaningful customer interactions, including onsite time</li><li>		Accuracy and timeliness of documentation on customer- meeting notes, health updates, contacts and contact roles</li><p><br></p></ul><h3>Required Skills</h3><ul><li>BA/BS Degree</li><li>Proven proficiency in technical roles or with technical software, including Excel skills</li><li>3-5+ years of direct customer facing, training, technical analyst or project management experience, preferably in the SaaS industry</li><p><br></p></ul><h3>Additional Expectations</h3><ul><li>Experience working cross functionally within a customer facing organization to support a joint outcome</li><li>Familiarity with the legal industry, bonus points if already proficient in FiIevine and Filevine Advanced tools</li><li>Strong aptitude for new technologies, and the ability to quickly diagnose needs and identify solutions</li><li>Excellent written, verbal, and oral communication with experience making presentations to key stakeholders</li><li>Strong attention to detail and documentation</li><li>Ability to work in a dynamic environment in which the requirements are not always well defined and priorities change frequently</li><li>Up to 15% travel to client sites (2-3 days per month)</li></ul><p><span>The base salary range represents the low and high end of the salary range for this position. The total compensation package for this position will be determined by each individual’s location, qualifications, education, work experience, skills and performance. We believe in the importance of pay equity - the range listed is just one component of Filevine’s total compensation package for employees. Other rewards may include commissions, stock options, a paid time off policy, as well as a comprehensive benefits package, including medical, dental, and vision.</span></p><p><b>Cool Company Benefits:</b></p><p>- A dynamic, rapidly growing company, focused on helping organizations thrive&nbsp;</p><p>- Medical, Dental, &amp; Vision Insurance (for full-time employees)</p><p>- Competitive &amp; Fair Pay</p><p>- Maternity &amp; paternity leave (for full-time employees)</p><p>- Short &amp; long-term disability</p><p>- Ergonomic and height-adjustable workstations for onsite employees</p><p>- Opportunity to learn from a dedicated leadership team</p><p>- Weekly Taco Lunches in the summer/fall/spring for onsite employees</p><p>- Centrally located open office building in Sugar House</p><p>- Flexible hybrid work schedules depending on the department with some departments offering fully remote positions in the United States (R&amp;D)</p><p>- Top-of-the-line company swag</p>`

let jobListings = [
    {
        id: "0",
        title:  "Job Listings",
        description:  "This is a random description for which we are to be",
        jobs: [{
            id: "1",
            company_id: "1",
            company: {
                id: "1",
                name: "Nextpay",
                logo: "https://res.cloudinary.com/dnfmabyz2/image/upload/v1678490198/maaxdltnmobigbg6zsj1.png",
                physical_address: "Plot 1, Coville Street"
            },
            title: "Senior Back-End Engineer",
            location: "New York only",
            salary_min: 90,
            salary_max: 140,
            salary: 0,
            salary_label: "$75K - $90K",
            show_range: true,
            date_posted: "2023-05-07",
            time_type: "Full-time",
            communiting: "Specified Remote",
            display_status: "active",
            skills: ["Customer", "Support", "Customer Success"],
            details: jobDetails
        },{
            id: "2",
            company_id: "2",
            company: {
                id: "2",
                name: "Zensurance",
                logo: "https://res.cloudinary.com/dnfmabyz2/image/upload/v1678493369/blzosckba1fa0oejfn5c.png",
                physical_address: "Plot 1, Coville Street"
            },
            title: "Team Lead, Accounts Customer Experience",
            location: "Canada Only",
            salary_min: 60,
            salary_max: 110,
            salary: 0,
            salary_label: "$60K - $110K",
            show_range: true,
            date_posted: "2023-01-23",
            time_type: "Full-time",
            communiting: "Specified Remote",
            display_status: "active",
            skills: ["Relationship Management", "Support"],
            details: jobDetails
        },{
            id: "3",
            company_id: "3",
            company: {
                id: "3",
                name: "Oxygen",
                logo: "https://res.cloudinary.com/dnfmabyz2/image/upload/v1678490527/cnbm3vz0s6wlgsofchz6.png",
                physical_address: "Plot 1, Coville Street"
            },
            title: "Bilingual Workforce Planning Supervisor - Spanish",
            location: "Remote",
            salary_min: 70,
            salary_max: 82,
            salary: 0,
            salary_label: "$60K - $110K",
            show_range: true,
            date_posted: "2023-07-04",
            time_type: "Full-time",
            communiting: "Fully Remote",
            display_status: "active",
            skills: ["Spanish", "Organisation Management"],
            details: jobDetails
        },{
            id: "4",
            company_id: "4",
            company: {
                id: "4",
                name: "Lucidworks",
                logo: "https://res.cloudinary.com/dnfmabyz2/image/upload/v1684299429/ck1uctvjaywym6y6yjqj.jpg",
                physical_address: "Plot 1, Coville Street"
            },
            title: "Junior Recruiter",
            location: "Canada Only",
            salary_min: 70,
            salary_max: 82,
            salary: 0,
            salary_label: "$60K - $110K",
            show_range: true,
            date_posted: "2023-06-03",
            time_type: "Full-time",
            communiting: "Fully Remote",
            display_status: "active",
            skills: [],
            details: jobDetails
        },{
            id: "5",
            company_id: "5",
            company: {
                id: "5",
                name: "Rocketpower",
                logo: "https://res.cloudinary.com/dnfmabyz2/image/upload/v1678491357/ebbknj1kbnzvg7m7mjah.png",
                physical_address: "Plot 1, Coville Street"
            },
            title: "Training Coordinators - Singapore",
            location: "Singapore",
            salary_min: 70,
            salary_max: 82,
            salary: 0,
            salary_label: "From $23K",
            show_range: true,
            date_posted: "2023-04-15",
            time_type: "Part-time",
            communiting: "On Site",
            display_status: "active",
            skills: ["Logistics", "Trainning"],
            details: jobDetails
        }],
        display_order: 1,
        status: "active",
        type: "job-listing"
    },
]

let posts = [{
    id: "1",
    title: "Lenovo ThinkPad T14 wont let me boot from usb drive.",  
    sub_title: "",
    reference_to_poster: "1",
    user: {
        id: "1",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "PortAreaGuy17",
        city: "",
        state: "",
        badges: [], //future upgrades
    },
    description: "",
    replies: [],
    likes: ["","","","","","","","","","","","","","","","","",""], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345
},{
    id: "2",
    title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
    sub_title: "He is a discreet collector who is specifically looking for a driver condition 330 GTC",
    reference_to_poster: "2",
    user: {
        id: "2",
        avatar: "",
        name: "mharlieedgington22",
        city: "",
        state: "",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff"
    },
    description: "",
    replies: [],
    likes: ["","","","","",""], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345,
}];

const post = {
    id: "2",
    title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
    reference_to_poster: "2",
    user: {
        id: "2",
        avatar: "",
        name: "mharlieedgington22",
        city: "New York",
        state: "New York State",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff",
        join_date: "2023-05-01",
        count_of_replies: 4566
    },
    description: 
    `
        <article>
            <blockquote className="messageText SelectQuoteContainer ugc baseHtml">
                I am seeking out a driver condition for a private client of mine.<br>
                <br>
                He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
                <br>
                Non-red preferred.<br>
                <br>
                Scruffier than nicer would best describe the desired overall condition.<br>
                <br>
                Good records without blemishes would be preferred.<br>
                <br>
                Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
                <br>
                NOT looking for a perfect car.<br>
                <br>
                Thanks!
                <div className="messageTextEndMarker">&nbsp;</div>
            </blockquote>
        </article>
    `,
    replies: [],
    likes: [{
        user_refrence: "1",
        user: {
            name: "Edward 96GTS",
        }
    },{
        user_refrence: "2",
        user: {
            name: "slm",
        }
    },{
        user_refrence: "3",
        user: {
            name: "Oengus",
        }
    },{
        user_refrence: "4",
        user: {
            name: "GLENN@TEAM AI",
        }
    },{
        user_refrence: "5",
        user: {
            name: "SCantera",
        }
    },{
        user_refrence: "6",
        user: {
            name: "msdesignltd",
        }
    },{
        user_refrence: "7",
        user: {
            name: "ashwin murali",
        }
    },{
        user_refrence: "8",
        user: {
            name: "Untertaker555 ",
        }
    },{
        user_refrence: "9",
        user: {
            name: "d43qd3dsa",
        }
    }], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345,
};

const post2 = {
    id: "2",
    title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
    reference_to_poster: "2",
    user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "PortAreaGuy17",
        city: "Phoenix",
        state: "Arizona",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff",
        join_date: "2021-75-01",
        count_of_replies: 56
    },
    description: 
    `
        I am seeking out a driver condition for a private client of mine.<br>
        <br>
        He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
        <br>
        Non-red preferred.<br>
        <br>
        Scruffier than nicer would best describe the desired overall condition.<br>
        <br>
        Good records without blemishes would be preferred.<br>
        <br>
        Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
        <br>
        NOT looking for a perfect car.<br>
        <br>
        Thanks!
        <div className="messageTextEndMarker">&nbsp;</div>
    `,
    replies: [],
    likes: [{
        user_refrence: "1",
        user: {
            name: "ditiro sekatuba",
        }
    },{
        user_refrence: "2",
        user: {
            name: "spunk funk",
        }
    },{
        user_refrence: "3",
        user: {
            name: "Corday",
        }
    }], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345,
};

const post3 = {
    id: "3",
    title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
    reference_to_poster: "2",
    user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "PortAreaGuy17",
        city: "Phoenix",
        state: "Arizona",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff",
        join_date: "2021-75-01",
        count_of_replies: 56
    },
    description: 
    `
        Wow.....100k? 
        <br>
        <br>
        I have not had a car painted [76 BB] since the early 80s. Don't plan on doing it anytime soon. 
        I acquire cars that someone else has made or kept in good condition. No restorations planned in my future.
        <div className="messageTextEndMarker">&nbsp;</div>
    `,
    replies: [],
    likes: [{
        user_refrence: "1",
        user: {
            name: "ditiro sekatuba",
        }
    },{
        user_refrence: "2",
        user: {
            name: "spunk funk",
        }
    },{
        user_refrence: "3",
        user: {
            name: "Corday",
        }
    }], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345,
    references_reply_id: "2",
    referenced_reply: {
        id: "2",
        description: `
            I am seeking out a driver condition for a private client of mine.<br>
            <br>
            He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
            <br>
            Non-red preferred.<br>
            <br>
            Scruffier than nicer would best describe the desired overall condition.<br>
            <br>
            Good records without blemishes would be preferred.<br>
            <br>
            Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
            <br>
            NOT looking for a perfect car.<br>
            <br>
            Thanks!
            <div className="messageTextEndMarker">&nbsp;</div>
        `,
        user: {
            id: "2",
            name: "PortAreaGuy17",
        },
    }
};

const breadcrumbPages = [
  { name: 'Projects', href: '#', current: false },
  { name: 'Project Nero', href: '#', current: true },
]

const post4 = {
    id: "3",
    title: "500 GB USB Pendrive turned RAW and Read-Only after cancelling Format",  
    sub_title: "He is a discreet collector who is specifically looking for a driver condition 330 GTC",
    reference_to_poster: "2",
    user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "PortAreaGuy17",
        city: "Phoenix",
        state: "Arizona",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff",
        join_date: "2021-75-01",
        count_of_replies: 56
    },
    description: 
    `
        Wow.....100k? 
        <br>
        <br>
        I have not had a car painted [76 BB] since the early 80s. Don't plan on doing it anytime soon. 
        I acquire cars that someone else has made or kept in good condition. No restorations planned in my future.
        <div className="messageTextEndMarker">&nbsp;</div>
    `,
    replies: [],
    likes: [{
        user_refrence: "1",
        user: {
            name: "ditiro sekatuba",
        }
    },{
        user_refrence: "2",
        user: {
            name: "spunk funk",
        }
    },{
        user_refrence: "3",
        user: {
            name: "Corday",
        }
    }], //( Array of references to people who liked the post )
    date_of_post: "2023-05-01 04:15:03",
    display_order: 23,
    status: "active",
    count_of_replies: 345,
    references_reply_id: "2",
    referenced_reply: {
        id: "2",
        description: `
            I am seeking out a driver condition for a private client of mine.<br>
            <br>
            He is a discreet collector who is specifically looking for a driver condition 330 GTC.<br>
            <br>
            Non-red preferred.<br>
            <br>
            Scruffier than nicer would best describe the desired overall condition.<br>
            <br>
            Good records without blemishes would be preferred.<br>
            <br>
            Ready to go for the right car, and figure a ballpark in consideration to be anywhere from $400-600K<br>
            <br>
            NOT looking for a perfect car.<br>
            <br>
            Thanks!
            <div className="messageTextEndMarker">&nbsp;</div>
        `,
        user: {
            id: "2",
            name: "PortAreaGuy17",
        },
    },
    forum: {
        id: "1",
        title: "Cars",
        icon: "truck",
        description: "This forum is for all those peopla that like cars",
        posts: [],
        reference_to_latest_post: "",
        display_order: 1,
        status: "active",
        count_of_posts: 3901,
        count_of_replies: 17520,
        latest_post: {
            id: "1",
            title: "There was no asking price. I am just responding to the OP looking for a ",
            date_of_post: "2023-05-01 04:15:03",
            user: {
                id: "1",
                name: "Jay535"
            }
        },
        community: {
            id: "1",
            title:  "Classifieds - Commercial",
            description:  "For sponsors, businesses, or high volume users.",
            display_order: 1,
            status: "active"
        },
    },
};

const post4BreadcrumbPages = [
    { name: 'Forums', href: '#', current: false },
    { name: post4.forum.community.title, href: '#', current: false },
    { name: post4.forum.title, href: '#', current: false },
];


const forumsBreadcrumbPages = [
    { name: 'Forums', href: '#', current: false },
    { name: communities[0].title, href: '#', current: false },
];

const communityRequests = [
    {
      id: 1,
      name: 'Dealers In white',
      imageUrl:
        'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      content:
        'Explicabo nihil laborum. Saepe facilis consequuntur in eaque. Consequatur perspiciatis quam. Sed est illo quia. Culpa vitae placeat vitae. Repudiandae sunt exercitationem nihil nisi facilis placeat minima eveniet.',
      date: '1d ago',
      dateTime: '2023-03-04T15:54Z',
      user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "mharlieedgington22",
        city: "",
        state: "",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff"
      },
      status: "pending",
      reason: "",
      createdCommunityUrl: ""
    },
    {
      id: 2,
      name: 'Exercises In the evening',
      imageUrl:
        'https://images.unsplash.com/photo-1519244703995-f4e0f30006d5?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      content:
        'Laudantium quidem non et saepe vel sequi accusamus consequatur et. Saepe inventore veniam incidunt cumque et laborum nemo blanditiis rerum. A unde et molestiae autem ad. Architecto dolor ex accusantium maxime cumque laudantium itaque aut perferendis.',
      date: '2d ago',
      dateTime: '2023-03-03T14:02Z',
      user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "mharlieedgington22",
        city: "",
        state: "",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff"
      },
      status: "created",
      reason: "Quia animi harum in quis quidem sint. Ipsum dolorem molestias veritatis quis eveniet commodi assumenda temporibus. Dicta ut modi alias nisi. Veniam quia velit et ut. Id quas ducimus reprehenderit veniam fugit amet fugiat ipsum eius. Voluptas nobis earum in in vel corporis nisi.",
      createdCommunityUrl: "http://localhost:3000/dashboard?cmty=Medical%20Conditions"
    },
    {
      id: 3,
      name: 'Dries Vincent',
      imageUrl:
        'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      content:
        'Quia animi harum in quis quidem sint. Ipsum dolorem molestias veritatis quis eveniet commodi assumenda temporibus. Dicta ut modi alias nisi. Veniam quia velit et ut. Id quas ducimus reprehenderit veniam fugit amet fugiat ipsum eius. Voluptas nobis earum in in vel corporis nisi.',
      date: '2d ago',
      dateTime: '2023-03-03T13:23Z',
      user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "mharlieedgington22",
        city: "",
        state: "",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff"
      },
      status: "rejected",
      reason: "We are happy that you considered the option of having this community, however we couldnot crrate this community because we do not have enough support for the requested activities at the moment. Thank you",
      createdCommunityUrl: ""
    },
    {
      id: 4,
      name: 'Lindsay Walton',
      imageUrl:
        'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      content:
        'Unde dolore exercitationem nobis reprehenderit rerum corporis accusamus. Nemo suscipit temporibus quidem dolorum. Nobis optio quae atque blanditiis aspernatur doloribus sit accusamus. Sunt reiciendis ut corrupti ab debitis dolorem dolorem nam sit. Ducimus nisi qui earum aliquam. Est nam doloribus culpa illum.',
      date: '3d ago',
      dateTime: '2023-03-02T21:13Z',
      user: {
        id: "2",
        avatar: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
        name: "mharlieedgington22",
        city: "",
        state: "",
        badges: [], //future upgrades
        name_initials_bg_color: "#06b6d4",
        name_initials_text_color: "#fff"
      },
      status: "pending",
      reason: "",
      createdCommunityUrl: ""
    },
]


const searchResults = [{
    id: 1,
    url: "/dashboard?view=Medical Conditions",
    image: "https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600",
    cleanHtmlBody: `The name of the community: <span className="text-purple-900 font-bold">Medical Conditions</span>`,
    title: "Medical Conditions",
    type: "community"
},{
    id: 2,
    url: "/dashboard?view=Medical Conditions",
    image: "https://tailwindui.com/img/logos/mark.svg?color=indigo&shade=600",
    cleanHtmlBody: `The name of the community: <span className="text-purple-900 font-bold">Medical Conditions</span>`,
    title: "Medical Conditions",
    type: "community"
}];


const labData = {
    jobListings,
    communities,
    posts,
    post,
    post2,
    post3,
    breadcrumbPages,
    post4,
    post4BreadcrumbPages,
    forumsBreadcrumbPages,
    pageSize: 15,
    communityRequests,
    searchResults
}

export default labData;